import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdCustomersRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-customers',
	path: '/projects/:projectKey/customers',
};
